import { actionTypes } from 'redux-form';

import { setStornoInsurancePrice, setTotalPrice, setPriceToPay, setTotalNoOfGuests, setNoOfNights } from './actions';
import { getBoardBaseTotalPrice, getBoardBasesTotalPrice, getExtraFeePrice, getRoomPrice, getNoOfNights, getTotalPricelistFees } from '../apiHelpers';

export default store => next => action => {
	// let the action go to the reducers
	next(action);

	if (action.type !== actionTypes.CHANGE) return;

	const state = store.getState();
	const formValues = state.form.bookingForm.values;
	const { rooms, currency, boardBase, stayType } = formValues;
	const { isAdvancePaymentRequired, advancePaymentPercentage, boardBases, applyGuestTypeDiscountToBoardBase, extraFees, guestTypes, stornoInsurance, apiRoomsResponse } = state.app;

	// Formulář ještě není inicializovaný
	if (!currency || !rooms || !apiRoomsResponse) return;

	const pricelistFees = apiRoomsResponse.pricelistFees;

	let stornoInsurancePrice = 0;
	let totalPrice = 0;
	let priceToPay = 0;
	let totalNoOfGuests = 0;
	const noOfNights = getNoOfNights(formValues.arrival, formValues.departure);

	for (let roomType of Object.keys(rooms)) {
		// Pro každý vybraný typ pokoje
		for (let selectedRoom of rooms[roomType]) {
			// Pro každý vybraný konkrétní pokoj
			totalNoOfGuests += Object.values(selectedRoom.guestTypes).reduce((accumulator, noOfGuests) => accumulator + noOfGuests, 0);
			const roomPrice = getRoomPrice(selectedRoom, currency, selectedRoom.guestTypes, guestTypes);
			totalPrice += roomPrice;

			// Automatické příplatky a slevy
			for (const extraFee of apiRoomsResponse.extraFees) {
				if (typeof extraFee.price === 'object') {
					// Cena zadaná pevnou částkou
					if (extraFee.price[currency.id]) {
						totalPrice += extraFee.price[currency.id] * (extraFee.daily ? noOfNights : 1);
					}
				} else {
					// Cena zadaná procentem z ceny ubytování
					totalPrice += roomPrice * extraFee.price / 100;
				}
			}

			// Zvolené příplatky a slevy
			if (selectedRoom.extraFees !== undefined) {
				for (const extraFeeId of Object.keys(selectedRoom.extraFees)) {
					if (selectedRoom.extraFees[extraFeeId]) {
						totalPrice += getExtraFeePrice(extraFees[extraFeeId], noOfNights, roomPrice, currency, false);
					}
				}
			}
		}
	}

	// Pojištění proti stornu (počítá se pouze z ceny za ubytování)
	if (stornoInsurance) {
		stornoInsurancePrice = totalPrice * stornoInsurance.percentageFee; // v totalPrice musí být pouze cena za ubytování (+ příplatky a slevy)
		if (formValues.stornoInsurance) {
			totalPrice += stornoInsurancePrice;
		}
	}

	// K celkové ceně přičíst poplatky
	totalPrice += getTotalPricelistFees(pricelistFees, rooms, noOfNights, currency, stayType);

	if (boardBase && boardBases) {
		// Připočítat stravu
		totalPrice += typeof boardBase === 'object'
			// Strava může být pro každoho hosta jiná
			? getBoardBasesTotalPrice(boardBases, boardBase, guestTypes, noOfNights, applyGuestTypeDiscountToBoardBase, formValues.currency, false)
			// Strava je pro všechny hosty stejná
			: getBoardBaseTotalPrice(boardBases[boardBase], guestTypes, rooms, noOfNights, applyGuestTypeDiscountToBoardBase, formValues.currency, false);
	}

	if (isAdvancePaymentRequired || (advancePaymentPercentage < 100 && formValues.advancePaymentOnly)) {
		priceToPay = (totalPrice * advancePaymentPercentage) / 100;
	} else {
		priceToPay = totalPrice;
	}

	store.dispatch(setStornoInsurancePrice(stornoInsurancePrice));
	store.dispatch(setTotalPrice(totalPrice));
	store.dispatch(setPriceToPay(priceToPay));
	store.dispatch(setTotalNoOfGuests(totalNoOfGuests));
	store.dispatch(setNoOfNights(noOfNights))
};


// WEBPACK FOOTER //
// ./src/store/totalPriceMiddleware.js